// extracted by mini-css-extract-plugin
module.exports = {"downloadExcelButton":"DownloadExcelButton_downloadExcelButton__2GJgQ"};